const STORE_URLS = {
  ios: "https://apps.apple.com/br/app/inside-brasil/id6737057631",
  default: "https://play.google.com/store/apps/details?id=br.com.inside.mobileApp",
} as const;

export const APP_SCHEME = "insidebrasil://";
export const ANDROID_PACKAGE = "br.com.inside.mobileApp";

export const APP_STORE_URL = STORE_URLS.ios;
export const PLAY_STORE_URL = STORE_URLS.default;

export const APPLE_STORE_ICON = "https://img.icons8.com/?size=100&id=95294&format=png&color=FFFFFF";
export const PLAY_STORE_ICON = "https://img.icons8.com/?size=100&id=22982&format=png&color=FFFFFF";

export const TERMS_URL = "https://ilumeo-brasil-com-br.s3.sa-east-1.amazonaws.com/termos-e-condicoes-de-uso-inside+brasil.pdf";

export const getStoreUrl = (): string => {
  const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  return isIos ? STORE_URLS.ios : STORE_URLS.default;
};

export const buildSurveyDeepLink = (params?: { original_survey_id?: string; invitation_id?: string }): string => {
  if (params?.original_survey_id) {
    return `insidebrasil://survey/${encodeURIComponent(params.original_survey_id)}`;
  }
  if (params?.invitation_id) {
    return `insidebrasil://invitation/${encodeURIComponent(params.invitation_id)}`;
  }
  return "insidebrasil://";
};
